import OwnerCertificationChartTooltip from 'components/tooltip/OwnerCertificationChartTooltip';
import OwnerCertificationChartTooltipCursor from 'components/tooltip/OwnerCertificationChartTooltipCursor';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  ChartOfferForm,
  ChartOfferFormResponse,
  ChartOption,
} from 'types/chart';
import { formatDanjiAveragePriceTick } from 'utils/formatUtil';

interface Props {
  chartData: ChartOfferFormResponse[];
  chartOption: ChartOption;
  chartKey: string;
  onChartClick: () => void;
  onChartMouseLeave: () => void;
  height: number;
}

function NaverOfferCountChart({
  chartData,
  chartOption,
  chartKey,
  height,
  onChartClick,
  onChartMouseLeave,
}: Props) {
  const { tooltipActive, xAxisProps, yAxisProps } = chartOption;

  return (
    <ResponsiveContainer>
      <BarChart
        data={chartData}
        key={chartKey}
        layout="vertical"
        margin={{ top: 5, right: 5, bottom: 5, left: 0 }}
        barGap={0}
        barCategoryGap={0}
        onClick={onChartClick}
        onMouseLeave={onChartMouseLeave}
      >
        <CartesianGrid vertical={false} fill="#F8FAFF" stroke="#E6E6E6" />
        <XAxis
          type="number"
          dataKey="offerCount"
          allowDecimals={false}
          interval={xAxisProps?.interval}
          domain={[0, 'dataMax']}
          axisLine={{ stroke: 'none' }}
          tick={{
            fill: '#BDBDBD',
            fontSize: '0.6rem',
            fontWeight: 700,
          }}
          padding={{
            right: 15,
          }}
          tickLine={false}
          tickFormatter={() => ''}
        />
        <YAxis
          hide
          dataKey="price"
          reversed
          type="number"
          interval={0}
          width={40}
          axisLine={false}
          tickLine={false}
          tick={{
            fill: '#BDBDBD',
            fontSize: '0.6rem',
            fontWeight: 700,
          }}
          tickCount={yAxisProps?.tickCount}
          ticks={yAxisProps?.ticks}
          domain={yAxisProps?.domain}
          tickFormatter={(value) => formatDanjiAveragePriceTick(value)}
        />

        <Bar
          dataKey="offerCount"
          fill="#9FC2FF"
          barSize={7}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default NaverOfferCountChart;
